// src/pages/Payment.js
import React from "react";
import { useParams } from "react-router-dom";

const Payment = () => {
  const { orderId } = useParams();

  const styles = {
    page: {
      minHeight: "100vh",
      background: "#000",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "Segoe UI, sans-serif",
      color: "#fff",
      padding: "20px"
    },

    card: {
      background: "#111",
      borderRadius: "20px",
      padding: "40px 30px",
      maxWidth: "420px",
      width: "100%",
      textAlign: "center",
      boxShadow: "0 0 25px rgba(212,175,55,0.25)",
      border: "1px solid rgba(212,175,55,0.3)"
    },

    logo: {
      width: "120px",
      height: "120px",
      objectFit: "cover",
      borderRadius: "50%",
      marginBottom: "15px",
      border: "3px solid #d4af37",
      padding: "3px",
      background: "#000"
    },

    title: {
      fontSize: "28px",
      fontWeight: "bold",
      color: "#d4af37",
      marginBottom: "10px"
    },

    message: {
      fontSize: "16px",
      lineHeight: "1.6",
      marginBottom: "25px",
      color: "#ddd"
    },

    orderBox: {
      background: "#000",
      border: "1px solid #d4af37",
      borderRadius: "10px",
      padding: "12px",
      fontSize: "14px",
      marginBottom: "25px",
      wordBreak: "break-all",
      color: "#d4af37"
    },

    button: {
      padding: "14px 35px",
      background: "#d4af37",
      color: "#000",
      border: "none",
      borderRadius: "8px",
      fontWeight: "bold",
      fontSize: "16px",
      cursor: "pointer",
      transition: "0.3s"
    },

    footer: {
      marginTop: "20px",
      fontSize: "13px",
      color: "#aaa"
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>

        {/* Logo */}
        <img src="https://sadhanlab.com/wrapper/wrapper_logo.png" alt="Wrapsy Logo" style={styles.logo} />

        {/* Title */}
        <div style={styles.title}>Thank You for Your Order!</div>

        {/* Message */}
        <div style={styles.message}>
          Your order has been received successfully.  
          Our team will communicate with you soon to confirm the details and guide you through the secure payment process.
        </div>

        {/* Order ID */}
        <div style={styles.orderBox}>
          Order ID: <br />
          {orderId}
        </div>

        {/* Button */}
        {/* <button style={styles.button}>
          Proceed to Secure Payment
        </button> */}

        {/* Footer */}
        <div style={styles.footer}>
          Wrapsy • Happiness Wrapped
        </div>

      </div>
    </div>
  );
};

export default Payment;
